export default __webpack_public_path__ + "static/media/car-wheel.97816556.png";